import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import cotacaoSlice from "./slices/cotacaoSlice";

const rootReducer = combineReducers({
  cotacao: cotacaoSlice,
});

export const store = configureStore({
  reducer: rootReducer,
});
